import React, { useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";
import SendLinkcard from "../../Components/AuthenticationComponents/SendLinkCard";
import LoaderComponent from "../../Components/Generic/LoaderComponent";
import { useNavigate } from "react-router-dom";

const ResetPasswordPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const navigateToWebpage = () => {
    window.location.replace("http://emotii.ai");
  };

  return (
    <LoaderComponent loading={loading}>
      <LogoWrapper>
        <img src="/emotii.avif" alt="Emotii Logo" />
      </LogoWrapper>
      <Container>
        <SendLinkcard setIsLoading={setLoading} />
      </Container>
    </LoaderComponent>
  );
};

export default ResetPasswordPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${lightThemeColors.menuBackground};
  min-height: 100vh;
  padding: 40px;
  box-sizing: border-box;

  @media (max-width: 650px) {
    padding: 20px;
  }
`;

const LogoWrapper = styled.div`
  position: fixed;
  top: 40px;
  left: 40px;
  max-width: 80px;
  width: 100%;
  z-index: 10;

  img {
    width: 100%;
    height: auto;
  }

  @media (max-width: 650px) {
    top: 20px;
    left: 20px;
    max-width: 60px;
  }
`;

